export default (phone, keyword = 'Hola') => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return `https://wa.me/${phone}/?text=${keyword}`;
    } else {
        return `https://api.whatsapp.com/send?phone=${phone}&text=${keyword}`;
    }
}